/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Icon, Container } from 'semantic-ui-react';
import styles from './AppFooter.module.scss';

const AppFooter = (props) => {
	return (
		<div className={styles.footer}>
			<div className={styles.top}>
				<Container>
					<div className={styles.topInner}>
						<div className={styles.right}>
							<div className={styles.logo}></div>
							<div>10 West 106th Street, Indianapolis, IN 46290</div>
							<div>© { new Date().getFullYear()} Indiana Farmers Mutual Insurance Group. Indiana Farmers Insurance is a registered trademark of Indiana Farmers Mutual Insurance Group</div>
							<div className={styles.links}>
								<a href='http://www.indianafarmers.com/legal-notice'>Legal Notice</a>
								<a href='http://www.indianafarmers.com/privacy-policy'>Privacy Policy</a>
							</div>
						</div>
					</div>
				</Container>
			</div>
			<div className={styles.bottom}>
				<Container>
					<div className={styles.bottomInner}>
						<div className={styles.copyright}>©{new Date().getFullYear()} by Paws, Inc. All Rights Reserved. “GARFIELD” and the GARFIELD characters are trademarks of Paws, Inc. Nickelodeon is a trademark of Viacom International Inc.</div>
						<div className={styles.socialLinks}>
							<div></div>

							<a href='https://www.facebook.com/indianafarmersinsurance/' target='_blank' rel='noopener noreferrer'>
								<Icon name='facebook square' size='big' />
							</a>
							{/* <a href='https://twitter.com/IndianaFarmers' target='_blank' rel='noopener noreferrer'>
								<Icon name='twitter square' size='big' />
							</a>
							<a href='https://www.instagram.com/indianafarmersinsurance/' target='_blank' rel='noopener noreferrer'>
								<Icon name='instagram' size='big' />
							</a> */}
							<a href='https://www.linkedin.com/company/986028' target='_blank' rel='noopener noreferrer'>
								<Icon name='linkedin square' size='big' />
							</a>
							<a href='https://www.youtube.com/user/IndianaFarmersMutual' target='_blank' rel='noopener noreferrer'>
								<Icon name='youtube play' size='big' />
							</a>
						</div>
					</div>
				</Container>
			</div>
		</div>
	);
};

export default AppFooter;
